import { Route } from '@angular/router';
import { productCategories } from '../../../datasets/content/productCategory';
import { ProductsComponent } from '../../../../../pages/datasets/products/products.component';
import { ProductsEditComponent } from '../../../../../pages/datasets/products-edit/products-edit.component';
import { ProductDetailsComponent } from '../../../../../pages/datasets/product-details/product-details.component';
import { ProductDetailsOverviewComponent } from '../../../../../pages/datasets/product-details/product-details-overview/product-details-overview.component';
import { ProductDetailsAttributesComponent } from '../../../../../pages/datasets/product-details/product-details-attributes/product-details-attributes.component';
import { ProductDetailsCategoriesComponent } from '../../../../../pages/datasets/product-details/product-details-categories/product-details-categories.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const products: Route = {
  path: 'products',
  title: 'lang.globals.products',
  data: {
    icon: SbIcons.product,
    breadcrumb: 'lang.globals.products',
    id: RoutingID.products,
  },
  children: [
    {
      path: '',
      component: ProductsComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'product-edit/:productID',
      title: 'lang.globals.product.edit',
      data: {
        icon: SbIcons.edit,
        breadcrumb: 'lang.globals.product.edit',
        id: RoutingID.productEdit,
      },
      children: [
        {
          path: '',
          component: ProductsEditComponent,
        },
      ],
    },
    {
      path: 'product-create',
      title: 'lang.globals.product.create',
      data: {
        icon: SbIcons.plus,
        breadcrumb: 'lang.globals.product.create',
        id: RoutingID.productCreate,
      },
      component: ProductsEditComponent,
    },
    {
      path: 'product-details/:productID',
      title: 'lang.globals.product.details',
      data: {
        icon: SbIcons.details,
        breadcrumb: 'lang.globals.product.details',
        id: RoutingID.productDetails,
      },
      children: [
        {
          path: '',
          component: ProductDetailsComponent,
          data: {
            breadcrumb: '',
          },
          children: [
            {
              path: 'product-overview',
              component: ProductDetailsOverviewComponent,
              title: 'nav.globals.product.details.overview',
              data: {
                breadcrumb: 'nav.globals.product.details.overview',
                icon: SbIcons.eye,
                id: RoutingID.productDetailsOverview,
              },
            },
            {
              path: 'product-attributes',
              component: ProductDetailsAttributesComponent,
              title: 'nav.globals.product.details.attributes',
              data: {
                breadcrumb: 'nav.globals.product.details.attributes',
                icon: SbIcons.attributes,
                id: RoutingID.productDetailsAttributes,
              },
            },
            {
              path: 'product-categories',
              component: ProductDetailsCategoriesComponent,
              title: 'lang.globals.productCategory',
              data: {
                breadcrumb: 'lang.globals.productCategory',
                icon: SbIcons.productCategory,
                id: RoutingID.productDetailsCategories,
              },
            },
            { path: '', redirectTo: RoutingID.productDetailsOverview, pathMatch: 'full' },
          ],
        },
      ],
    },
    productCategories,
  ],
};
